// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SuccessMessage_SuccessMsg__fTMdE {\n    margin-bottom: 30px;\n    margin-top: -25px;\n    font-size: 16px;\n  }\n", "",{"version":3,"sources":["webpack://./src/components/SuccessMessage.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;EACjB","sourcesContent":[".SuccessMsg {\n    margin-bottom: 30px;\n    margin-top: -25px;\n    font-size: 16px;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"SuccessMsg": "SuccessMessage_SuccessMsg__fTMdE"
};
export default ___CSS_LOADER_EXPORT___;
